import { render, staticRenderFns } from "./ErrorSnack.vue?vue&type=template&id=1d121b0b&scoped=true&"
import script from "./ErrorSnack.vue?vue&type=script&lang=ts&"
export * from "./ErrorSnack.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorSnack.vue?vue&type=style&index=0&id=1d121b0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d121b0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
